module.exports = __webpack_public_path__ + "static/media/logo-poxalulu.585cd1b1.svg";